import React from 'react';
import classes from '../InviteUsersModal.module.scss';
import { useTranslation } from 'react-i18next';

type CorrectTitleProps = {
  currentSection: string;
  nameOfChoosenGroup: string | undefined;
};

const CorrectTitle = ({currentSection, nameOfChoosenGroup}: CorrectTitleProps) => {
  const { t } = useTranslation();  

  switch (currentSection) {
    case 'users':
    case 'createLink':
      return <div>
      <div>{t('Users.modals.invite.title')}</div>
      <div className={classes.subTitle}>{nameOfChoosenGroup}</div>
    </div>;
    case 'roles':
      return <div>
        <div>{t('Users.modals.invite.title')}</div>
        <div className={classes.subTitle}>{t('Users.modals.invite.selectRole')}</div>
      </div>;
    case 'newRole':
      return <>{t('Users.modals.configureRoles.creatingNewRole')}</>;
    default:
      return <>{t('Users.modals.invite.title2')}</>;
  }
}

export default CorrectTitle;
